import { first } from 'lodash'
import { ParsedUrlQuery } from 'querystring'

const DEFAULT_REDIRECT_ROUTE = '/'

export const parseNextPageUrl = (query: ParsedUrlQuery) =>
  (Array.isArray(query.next) ? first(query.next) : query.next) ?? DEFAULT_REDIRECT_ROUTE

export const parseQRVerifyCode = (query: ParsedUrlQuery) =>
  (Array.isArray(query.verify_code) ? first(query.verify_code) : query.verify_code) ?? null

export const hasNextPage = (nextPage: string) => nextPage !== DEFAULT_REDIRECT_ROUTE
